import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-2c4e6625")
const _hoisted_1 = { class: "search-download" }
const _hoisted_2 = { class: "p-input-icon-right" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "noOffers"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-circle noOffersIcon" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "fontWeight500" }, "No pudimos encontrar empresas", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Prueba usando otras palabras.", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "card-container" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_CompanyCard = _resolveComponent("CompanyCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_InputText, {
          placeholder: "Buscar empresa",
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.search = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_3
      ]),
      _createVNode(_component_Button, {
        icon: "pi pi-download",
        label: "Reporte",
        class: "download-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createExcel()))
      }),
      _withDirectives(_createVNode(_component_DataTable, {
        value: _ctx.allCompanies,
        ref: "companiesTable",
        responsiveLayout: "scroll",
        exportFilename: "Información de compañías"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Button, {
            icon: "pi pi-download",
            label: "Descargar",
            class: "p-button-outlined p-button-help",
            onExport: _cache[2] || (_cache[2] = ($event: any) => (_ctx.exportCSV($event)))
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_Column, {
              header: "Nombre de la empresa",
              field: "name"
            }),
            _createVNode(_component_Column, {
              header: "Sector",
              field: "sector"
            })
          ])
        ]),
        _: 1
      }, 8, ["value"]), [
        [_vShow, false]
      ])
    ]),
    (!_ctx.companies.length && _ctx.hasRequestedCompanies)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
        return (_openBlock(), _createBlock(_component_CompanyCard, {
          result: company,
          key: company.ID
        }, null, 8, ["result"]))
      }), 128))
    ])
  ]))
}